import { supabase } from "../index";
import { toast } from "react-toastify";
import React, { useState } from "react";
import { toastobj } from "../commonutilities";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Input,
  FormFeedback,
  FormGroup,
} from "reactstrap";
import {
  faThumbsUp,
  faThumbsDown,
  faCircleQuestion,
} from "@fortawesome/free-solid-svg-icons";
import { useFormik } from "formik";
import { detailsFeedbackScheme } from "../ValidationSchema/Schema";

const Details = (props) => {
  const [misunderstoodContext, setMisunderstoodContext] = useState("");
  const [tkeyword, setTkeyword] = useState("");
  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    handleBlur,
    touched,
    resetForm,
    setFieldValue,
  } = useFormik({
    initialValues: {
      text: "",
    },

    validationSchema: detailsFeedbackScheme,
    onSubmit: (values, action) => {
      // Handle your form submission here
      // console.log(values);
      action.resetForm();
      handleMisunderstoodContext();
      toggleagreewithsome();
    },
  });

  const handleMisunderstoodContext = async () => {
    if (props?.guest) {
      toast.error("Please Login to continue", toastobj);
      return;
    }
    supabase
      .from("dream_details")
      .update({ misunderstood_context: values.text })
      .eq("id", props.data[tkeyword]["id"])
      .then((res) => {});
  };

  const [modelagreewithsome, setagreewithsome] = useState(false);
  const toggleagreewithsome = (keyword = "") => {
    if (props?.guest) {
      toast.error("Please Login to continue", toastobj);
      return;
    }
    setTkeyword(keyword);
    setMisunderstoodContext("");
    setagreewithsome(!modelagreewithsome);
  };

  const trimvalue = (val) => {
    if (val) {
      let trimval = val.replace(/[\r\n]{2,}/g, "\n");
      let arr = trimval.split("\n");
      return arr;
    } else {
      return [];
    }
  };
  // console.log(props.data);

  return (
    <>
      {props.data &&
        props.data.length > 0 &&
        props.data.map((pair, keywordIndex) => (
          <div
            className="analysis-tab1-content"
            key={keywordIndex}
            style={{
              borderBottom:
                keywordIndex === props.data.length - 1
                  ? "none"
                  : "0.5px solid rgba(255, 255, 255, 0.3)",
            }}
          >
            <p>
              <strong>{pair.keyword}</strong>{" "}
              {trimvalue(pair.value).map((item, index) => (
                <span
                  className="capitalfirstword"
                  key={index}
                  style={{
                    whiteSpace: "pre-line",
                    display: index !== 0 && "block",
                    marginTop: index !== 0 && "15px",
                  }}
                >
                  {item}
                </span>
              ))}
            </p>
            <ul>
              <li>
                <button
                  className="type mr-3"
                  style={{
                    backgroundColor:
                      pair["status"] === "agree" ? "#fff" : "transparent",
                  }}
                  onClick={() => props.handleagree(keywordIndex)}
                >
                  <FontAwesomeIcon icon={faThumbsUp} color="green" />
                </button>
              </li>
              <li>
                <button
                  className="type mr-3"
                  style={{
                    backgroundColor:
                      pair["status"] === "disagree" ? "#fff" : "transparent",
                  }}
                  onClick={() => props.handledisagree(keywordIndex)}
                >
                  <FontAwesomeIcon icon={faThumbsDown} color="red" />
                </button>
              </li>
              <li>
                <button
                  className="type mr-3"
                  onClick={() => {
                    toggleagreewithsome(keywordIndex);
                  }}
                >
                  Misunderstood
                </button>
              </li>
              <li className="anlysis-questionmark">
                <FontAwesomeIcon icon={faCircleQuestion} color={"#8850ff"} />
                <div className="anlysis-questionmark-info">
                  If you feel we didn't quite understand the meaning of this
                  symbol please let us know.
                </div>
              </li>
            </ul>
          </div>
        ))}
      <Modal isOpen={modelagreewithsome} toggle={toggleagreewithsome}>
        <ModalHeader toggle={toggleagreewithsome}></ModalHeader>
        <ModalBody>
          <div className="text-center payment-done-modal">
            <div>
              <QuestionMarkIcon className="payment-done-checkicon" />
            </div>
            <label>Help us improve, what we misunderstood ?</label>
            <br />
            <br />
            <form onSubmit={handleSubmit} autoComplete="off">
              <FormGroup className="position-relative">
                <Input
                  name="text"
                  type="text"
                  placeholder="Enter reason here..."
                  value={values.text}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  valid={touched.text && !errors.text}
                  invalid={touched.text && !!errors.text}
                  // onChange={(e) => setMisunderstoodContext(e.target.value)}
                />
                {touched.text ? (
                  <FormFeedback className="text-left">
                    {errors.text}
                  </FormFeedback>
                ) : null}
              </FormGroup>
              <br />
              <br />
              <Button className="w-50 btn-primary" type="submit">
                Submit
              </Button>
            </form>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default Details;
